<template>
    <div  id="draggable-1">
        {{ShowHidePopUp}}
        <div v-if="openclosepopup" >
            <transition name="modal" >
                <div class="" >
                    <div class="modal-wrapper" >
                        <div class="modal-container modal-width500" >
                            <!-- <div id="otEmbedContainer" style="width:800px; height:640px"></div> -->
                            <!-- <script type="application/javascript" src="https://tokbox.com/embed/embed/ot-embed.js?embedId=75731a68-9ed7-4622-bd29-77f23eed9d7c&room=0f403b39-7d98-42b6-bd72-ff7ca3f0e795"></script> -->
                            <!-- @mousedown="dragElement" -->
                            <div id="mydiv" style="cursor: move;"  class="modal-body" >
                                <div id="mydivheader" class="prompt-style-sml"> 
                                    <!-- <button type="button" data-dismiss="modal" @click="$emit('cancelAction')" class="close d-close">
                                    <i class="material-icons">close</i>
                                    </button> -->
                                    Click here to move
                                </div>
                                <p class="prompt-style-sml">
                                    <!-- <div id="otEmbedContainer" style="width:800px; height:640px;"></div> -->
                                    <!-- <script type="application/javascript" src="https://tokbox.com/embed/embed/ot-embed.js?embedId=75731a68-9ed7-4622-bd29-77f23eed9d7c&room=0f403b39-7d98-42b6-bd72-ff7ca3f0e795"></script> -->
                                    <!-- <iframe src="https://tokbox.com/embed/embed/ot-embed.js?embedId=75731a68-9ed7-4622-bd29-77f23eed9d7c&room=0f403b39-7d98-42b6-bd72-ff7ca3f0e795&iframe=true" width=800 height=640 scrolling="auto" allow="microphone; camera" ></iframe> -->
                                    <div id="vdoiframecontainer">
                                        <!-- <iframe :src="vdodataurl" width=400 height=400 scrolling="auto" allow="microphone; camera" ></iframe> -->
                                        <div id="videos">
                                            <div id="subscriber"></div>
                                            <div id="publisher"></div>
                                            <div class="btn-info-hold">
                                                <button @click.prevent="disconnectCall" id="disconnectpublisher" style=" padding: 8px;cursor:pointer;"></button>
                                               <!--  <button @click.prevent="getlayoutclassinfo" id="getlayoutclassinfo" style="border:0;width:50%">GetLayout Class Info</button>-->
                                            </div>
                                        </div>
                                    </div>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import rest_service from "@/api/rest_service";
import Axios from "axios";
const OT = require('@opentok/client');

export default {
    props:["apptobj","showhide","loggedinuser"],
    data(){
        return {
            isVideoApp:false,
            openclosepopup:false,
            appointmentObj:null,
            tenantid:null,
            tokboxScriptUrl:null,
            vdodataurl:"https://tokbox.com/embed/embed/ot-embed.js?embedId=[[VID_EMBED_ID]]&room=[[VID_ROOM_ID]]&iframe=true",
            opentokconfigobj:null,
            connectionCount:null,
            session:null,
            publisher:null,
            subscriber:null,
            publisherProperties: {resolution: '1280x720'},
            apiKey:null,
            streamid:null,
        }
    },
    computed:{
        ShowHidePopUp(){
            this.openclosepopup = this.showhide;
            var self = this;
            if(this.openclosepopup){
                this.appointmentObj = this.apptobj;
                this.tenantid = this.appointmentObj.tenant_id?this.appointmentObj.tenant_id:localStorage.tenantid;
                this.openVideoCallPopup(this.appointmentObj.unique_id);

                /** EMBED CODE -- COMMENTED */
                // self.vdodataurl=self.vdodataurl.replace("[[VID_EMBED_ID]]",this.appointmentObj.vid_detail.embed_id);
                // self.vdodataurl=self.vdodataurl.replace("[[VID_ROOM_ID]]",this.appointmentObj.vid_detail.rid);
                // //75731a68-9ed7-4622-bd29-77f23eed9d7c
                // //self.loadVideo();
            }
            else{
                if(self.session && self.publisher)
                {
                    self.session.unpublish(self.publisher);
                }
                if(self.publisher)
                {
                    self.publisher.destroy();
                }
            }
        }
    },
    methods:{
        openVideoCallPopup(id){

            //USING EMBED CODE

            // if(!this.showhidevirtualcallpopup && this.appointmentdetails && this.appointmentdetails.vid_detail && this.appointmentdetails.vid_detail.aid && this.appointmentdetails.vid_detail.rid)
            // {
            //   this.showhidevirtualcallpopup=true;
                
            //   //if(this.openclosepopup){
            //     //this.appointmentObj = this.apptobj;
            //     this.vdodataurl=this.vdodataurl.replace("[[VID_EMBED_ID]]",this.appointmentdetails.vid_detail.embed_id);
            //     this.vdodataurl=this.vdodataurl.replace("[[VID_ROOM_ID]]",this.appointmentdetails.vid_detail.rid);
            //     //
            //   //}
            // }

            //USING VIDEO API
            let role_unique_id=null;
            if (this.loggedinuser != null && this.loggedinuser.role) {
               role_unique_id = this.loggedinuser.role.unique_id;
            }
            var config = {
                method: 'get',
                url: rest_service.baseURL+'/telecommunication/createvideosession?id='+id,
                headers: {
                    'accept': 'application/json',
                    'accept-encoding': 'gzip, deflate, br',
                    'loggedin_user_unique_id': this.loggedinuser.unique_id,
                    'x_tenant_id': localStorage.tenantid,
                    'Authorization': localStorage.accesstoken,
                    'route_entity_name': '/telecommunication',
                    'role_unique_id': role_unique_id,
                }
            };
            var self = this;
            rest_service.getRequest(config)
            .then(response=> {
                if(response && response.data && response.data.opentokSession && response.data.opentokToken)
                {
                    console.log("OPENTOK OBJECT>>>>>>>>>>>>>>",response.data);
                    self.opentokconfigobj = response.data;

                    self.apiKey = self.opentokconfigobj.opentokSession.apiKey;
                    var sessionId = self.opentokconfigobj.opentokSession.id;
                    var token = self.opentokconfigobj.opentokToken;
                    
                    var dname = (self.loggedinuser.title?self.loggedinuser.title+" ":"")+(self.loggedinuser.first_name?self.loggedinuser.first_name:"")+(self.loggedinuser.last_name?" "+self.loggedinuser.last_name:"");
                    if(!OT.checkSystemRequirements() == 1)
                    {
                        alert("Your system does not fullfill the requirement to start the video call. Please contact Genamet support.");
                    }
                    else
                    {
                        self.session = OT.initSession(self.apiKey, sessionId);
                        self.publisher = OT.initPublisher('publisher', {
                            insertMode: 'replace',
                            width: '100%',
                            height: '100%',
                            resolution: '1280x720',
                            name:dname,
                            style: { nameDisplayMode: "auto" },
                            type:'pip'
                        }, handleError);
                        
                        self.session.connect(token, function(error) {
                            // If the connection is successful, publish to the session
                            if (error) {
                                handleError(error);
                            } else {
                                if (self.session.capabilities.publish == 1) {
                                //document.getElementById('disconnectpublisher').style.display = 'block';
                                self.session.publish(self.publisher, handleError);
                                } else {
                                console.log("You cannot publish an audio-video stream.");
                                }
                            }
                        });
                        //Session Events
                        self.session.on({
                            "streamCreated": function(event) {
                                self.subscriber=self.session.subscribe(event.stream,"subscriber",{insertmode:'replace'},function(error){
                                    if (error) {
                                        console.log("Subscribe Method>>>>",error);
                                    } else {
                                        self.streamid = event.stream;
                                        console.log('Subscriber added.',self.streamid);
                                    }
                                });
                            },
                            "connectionCreated": function (event) {
                                self.connectionCount++;
                                if (event.connection.connectionId != self.session.connection.connectionId) {
                                console.log('Another client connected. ' + self.connectionCount + ' total.');
                                }
                            },
                            "connectionDestroyed": function connectionDestroyedHandler(event) {
                                self.connectionCount--;
                                console.log('A client disconnected. ' + self.connectionCount + ' total.');
                            },
                            "sessionDisconnected": function sessionDisconnectHandler(event) {
                                // The event is defined by the SessionDisconnectEvent class
                                console.log('Disconnected from the session.');
                                document.getElementById('disconnectpublisher').style.display = 'none';
                                if (event.reason == 'networkDisconnected') {
                                console.log('Your network connection terminated.')
                                }
                            }
                        });
                        //Publisher Events
                        self.publisher.on({
                            accessAllowed: function (event) {
                                // The user has granted access to the camera and mic.
                                console.log("User has granted access to the camera & mic");
                            },
                            accessDenied: function (event) {
                                // The user has denied access to the camera and mic.
                                console.log("The user has denied access to the camera and mic");
                            },
                            accessDialogOpened: function (event) {
                                //pleaseAllowCamera.style.display = 'block';
                                console.log("The Allow/Deny dialog box is opened");
                            },
                            accessDialogClosed: function (event) {
                                //pleaseAllowCamera.style.display = 'none';
                                console.log("The Allow/Deny dialog box is closed");
                            },
                            streamCreated: function (event) {
                                console.log('The publisher started streaming.');
                                self.streamid=event.stream.id;
                                console.log('Subscriber added.',self.streamid);
                                console.log('Stream resolution: ' +event.stream.videoDimensions.width +'x' + event.stream.videoDimensions.height);
                            },
                            streamDestroyed: function (event) {
                                console.log("The publisher stopped streaming. Reason: "+ event.reason);
                            }
                        });

                        function handleError(error) {
                            if (error) {
                                console.log(error.message);
                                switch (error.name) {
                                case "OT_NOT_CONNECTED":
                                    alert("Publishing your video failed. You are not connected to the internet.");
                                    break;
                                case "OT_CREATE_PEER_CONNECTION_FAILED":
                                    alert("Publishing your video failed. This could be due to a restrictive firewall.");
                                    break;
                                case "OT_USER_MEDIA_ACCESS_DENIED":
                                    alert('Please allow access to the Camera and Microphone and try publishing again.');
                                default:
                                    alert("An unknown error occurred while trying to publish your video. Please try again later.");
                                }
                                self.publisher.destroy();
                                self.publisher = null;
                            }
                            else
                            {
                                console.log('Publisher initialized.');
                            }
                        }
                    }                    
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        getlayoutclassinfo()
        {
            var config = {
                method: 'get',
                url: "https://api.opentok.com/v2/project/"+this.apiKey+"/session/"+this.opentokconfigobj.opentokSession.id+"/stream/"+this.streamId,
                headers: {
                    'accept': 'application/json',
                    'accept-encoding': 'gzip, deflate, br',
                    'loggedin_user_unique_id': this.loggedinuser.unique_id,
                    'x_tenant_id': localStorage.tenantid,
                    'Authorization': localStorage.accesstoken,
                    'route_entity_name': '/telecommunication',
                    'role_unique_id': role_unique_id,
                }
            };
            var self=this;
            rest_service.getRequest(config)
            .then(response=> {

            });
        },
        disconnectCall(){
            var self = this;
            if(self.session)
            {
                self.session.unpublish(self.publisher);
            }
            if(self.publisher)
            {
                self.publisher.destroy();
            }
            self.$parent.showhidevirtualcallpopup=false;
        }
    },
    updated(){
    }
}
</script>



<style scoped>
    #otEmbedContainer{    overflow: hidden;
        box-shadow: none;
        border: 0;}
    .modal-mask {
    position: fixed;
    z-index: 9998;width:400px;height:400px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
    }

    .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    }
    .modal-container.modal-width500 .modal-body{padding:0;}
    .modal-container {
    width: 400px;
    height:400px;
    margin: 0px !important;
    padding:0; 
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease; position:relative;
    }
    .prompt-style-sml{line-height:30px;}
    .modal-header h3 {
    margin-top: 0;
    color: #42b983;
    }

    .modal-body {
    margin: 20px 0;
    }

    .modal-default-button {
    float: right;
    }



    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
    opacity: 0;
    }

    .modal-leave-active {
    opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
    }

    .modal-container.modal-width400{max-width:400px; width:400px;max-height:400px; height:400px;}
    .modal-container.modal-width500 .modal-header{border-bottom:1px solid transparent !important; padding-bottom: 0px !important;}
    .modal-container.modal-width500 .modal-footer{border-top:1px solid transparent !important;}
    .modal-container.modal-width500 .modal-header{min-height: 10px !important;}
    .modal-container.modal-width500 .modal-body{margin: 0px !important;}


    #videos {
        position: relative;
        width: 400px;  
        height:  400px;  
        margin-left: auto;
        margin-right: auto;
    }

    #publisher {
        position: absolute;
        right: 0;
        bottom: 0px;left:auto;top:auto;
        width: 100px !important;
        height: 100px !important;
        z-index: 1000; background:#ffff;
    }
    .videohold{height: 500px !important;}

    #subscriber {
        position: absolute !important;
        width: 400px !important;
        height: 400px !important;
        top: 0px;
        left: 0px;
        z-index: 100;
        border: 1px solid white;z-index:10px;
        border-radius: 3px; background:#fff;
    }
    .btn-info-hold{position:absolute;z-index: 1000;bottom:0;width:100%; padding-bottom:15px;text-align:center;border:0;border-top:0;}
    #disconnectpublisher{background:red url(../../static/images/calll.png)no-repeat;border:0;background-position: center; width:35px;height:35px;border-radius:50%; }
</style>